// Static USD-base FX table. Source: approximate mid-market rates from xe.com on 2026-05-13.
// TODO: replace with live rates via exchangerate.host or open.er-api.com (cache daily in Supabase).
export const RATES_UPDATED = '2026-05-13';

export const USD_RATES = {
  USD: 1.0,
  AUD: 1.52,
  GBP: 0.79,
  CAD: 1.37,
  NZD: 1.66,
  SGD: 1.34,
  AED: 3.67,
  EUR: 0.92,
  ZAR: 18.40,
};

export const CURRENCIES = [
  { code: 'USD', label: 'US Dollar' },
  { code: 'AUD', label: 'Australian Dollar' },
  { code: 'GBP', label: 'British Pound' },
  { code: 'CAD', label: 'Canadian Dollar' },
  { code: 'NZD', label: 'New Zealand Dollar' },
  { code: 'SGD', label: 'Singapore Dollar' },
  { code: 'AED', label: 'UAE Dirham' },
  { code: 'EUR', label: 'Euro' },
  { code: 'ZAR', label: 'South African Rand' },
];

export const convertFromUSD = (usd, code) => {
  const rate = USD_RATES[code] ?? 1;
  return usd * rate;
};

export const formatCurrency = (usd, code, opts = {}) => {
  const value = convertFromUSD(usd, code);
  const { minimumFractionDigits = 2, maximumFractionDigits = 2 } = opts;
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: code,
      minimumFractionDigits,
      maximumFractionDigits,
    }).format(value);
  } catch {
    return `${code} ${value.toFixed(maximumFractionDigits)}`;
  }
};

const CURRENCY_KEY = 'tt_preferred_currency';

export const loadPreferredCurrency = () => {
  try {
    const v = localStorage.getItem(CURRENCY_KEY);
    if (v && USD_RATES[v]) return v;
  } catch {}
  return 'USD';
};

export const savePreferredCurrency = (code) => {
  try { localStorage.setItem(CURRENCY_KEY, code); } catch {}
};
